import type { DisplayTextLabelPart } from '@vista-digital/occ-domain'
import type { NavigateFunction } from 'react-router-dom'
import { Services } from '../../services/services'
import { openInNewTab } from '../../utils/window/openInNewTab'
import type {
    CmsDisplayTextLabel,
    CmsDisplayTextLabelLink,
    CmsDisplayTextLabelPart,
} from '../types/cmsDisplayTextLabel'
import type { CmsLink } from '../types/cmsLink'

export const cmsToOccDisplayText = (
    label: CmsDisplayTextLabel,
    navigate?: NavigateFunction,
    internalActions?: { [key: string]: string }
): DisplayTextLabelPart[] => {
    return (
        label?.map(l => {
            if (isCmsDisplayTextLink(l)) {
                return l.link ? getLink(l.link, navigate) : ''
            } else {
                if (internalActions) {
                    for (const key in internalActions) {
                        if (l.text.indexOf(key) >= 0) return getInternalAction(l.text, internalActions[key])
                    }
                }
                return l.text
            }
        }) ?? []
    )
}

const isCmsDisplayTextLink = (displayTextPart: CmsDisplayTextLabelPart): displayTextPart is CmsDisplayTextLabelLink => {
    return 'link' in displayTextPart
}

const getLink = (link: CmsLink, navigate?: NavigateFunction): DisplayTextLabelPart => {
    return {
        text: link.name,
        href: link.url,
        openInNewTab: link.target && link.target === '_blank' ? true : false,
        onClick: () => {
            linkClick(link, link.target && link.target === '_blank' ? true : false, navigate)
        },
    }
}

const linkClick = (link: CmsLink, newTab: boolean, navigate?: NavigateFunction) => {
    if (!newTab && Services.UrlService.isRouted(link.url)) {
        setTimeout(() => {
            if (navigate) navigate(link.url)
            else window.navigate(link.url)
        }, 10)
    } else {
        if (newTab) openInNewTab(link.url)
        // eslint-disable-next-line no-restricted-properties -- allow for external links
        else document.location.assign(link.url)
    }
}

const getInternalAction = (text: string, internalAction: string): DisplayTextLabelPart => {
    return {
        text: text,
        internalAction: internalAction,
    }
}
